module.exports = __webpack_public_path__ + "40c5c96cd86102f8f14f9df895f13a5d.MP3";